var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.safe))]),_c('p',[_vm._v(_vm._s(_vm.info.appCodeName))]),_c('p',[_vm._v(_vm._s(_vm.info.appName))]),_c('p',[_vm._v(_vm._s(_vm.info.appVersion))])])
}
var staticRenderFns = []

export { render, staticRenderFns }